import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ViewerRoutingModule } from './viewer-routing.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

import { NgxSpinnerModule } from 'ngx-spinner';
import { TypeaheadModule } from 'ngx-bootstrap/typeahead';
import { ViewerComponent } from './pages/viewer/viewer.component';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { PaginationModule } from 'ngx-bootstrap/pagination';
import { CommonControlModule } from '../../core/components/common-control.module';
import { TooltipModule  } from 'ngx-bootstrap/tooltip';
import { SearchFieldsComponent } from './pages/search-fields/search-fields.component';
import { ResultComponent } from './pages/result/result.component';
import { DocviewerComponent } from './pages/docviewer/docviewer.component';
import { NgxDocViewerModule } from 'ngx-doc-viewer';
import { DetailViewerComponent } from './pages/detail-viewer/detail-viewer.component';
import { EsriMapComponent } from './pages/esri-map/esri-map.component';
import { ScrollToTopComponent } from './pages/scroll-to-top/scroll-to-top.component';


@NgModule({
  declarations: [
    ViewerComponent,
    SearchFieldsComponent,
    ResultComponent,
    DocviewerComponent,
    DetailViewerComponent,
    EsriMapComponent,
    ScrollToTopComponent
  ],
  imports: [
    CommonModule,
    ViewerRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    CommonControlModule,
    NgxSpinnerModule,
    NgxDocViewerModule,
    TypeaheadModule.forRoot(),
    PaginationModule.forRoot(),
    TooltipModule.forRoot()
  ],
  providers: [BsModalService, BsModalRef]
})
export class ViewerModule { }
